/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {useCamp, useClient, useCompany, useSite} from '../../../../../central/hooks'
import {
  deleteManagementSequential,
  getManagementSequential,
  getStatusManagementSequential,
  updateStatusManagementSequential,
} from '../../../../services'
import {MSquentialColumnModel, StatusSequence} from '../../../../model'
import {ShowSnackBar} from '../../../../../../util/functions'
import useTableForMaster from '../../../../hooks/useTableForMaster'
const TableManagementSequential: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    setUpdateTable,
    setClearTable,
    clearTable,
    selectedOn,
    updateTable,
    selected,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {typeCodesSequence, getCodesSequencenList} = useTableForMaster()

  const {searchValues, clearSearchValues} = useKhipu()
  const {siteList, getSiteList, handleClear: handleClearSite} = useSite()
  const {clientList, getClientList, handleClear: handleClearClient} = useClient()
  const {companyList, getCompanyList, handleClear: handleClearCompany} = useCompany()
  const {campList, getCampList, handleClear: handleClearCamp} = useCamp()
  const [status, setStatus] = useState<any[]>([])

  const getStatusSequenceList = async () => {
    try {
      const response = await getStatusManagementSequential()
      if (response.data.error) {
        setStatus([])
        return
      }
      const statusData: StatusSequence[] = response.data.data
      const mappedData = statusData.map((item) => ({
        value: item.id,
        label: item.acronimo,
      }))
      setStatus(mappedData)
    } catch (error) {
      console.log('Error fetching status sequences:', error)
      setStatus([])
    }
  }

  const getManagementSequentialList = async () => {
    setLoading(true)

    try {
      const response = await getManagementSequential(searchValues, pagination.currentPage, 10)
      const mappedData = response.data.data.map((item: MSquentialColumnModel) => ({
        ...item,
        Id: item.id,
      }))
      setData(mappedData)
      setPagination({
        ...pagination,
        totalResults: response.data.total,
      })
    } catch (error) {
      console.error('Error fetching management sequential data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCompanyList()
    getSiteList()
    getClientList()
    getCampList()
    getManagementSequentialList()
    getStatusSequenceList()
    getCodesSequencenList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getManagementSequentialList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])

  const columns: Column<MSquentialColumnModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={true} />,
        id: 'selection',
        Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].id} />,
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name='companiaId'
            selecteable
            data={companyList}
          />
        ),
        accessor: 'compania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name='clienteId'
            selecteable
            data={clientList}
          />
        ),
        accessor: 'cliente',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name='siteId' selecteable data={siteList} />
        ),
        accessor: 'site',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='campamentoId'
            selecteable
            // data={[{value: '0', label: 'TODOS'}, ...campList]}
            data={campList}
          />
        ),
        accessor: 'campamento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Código'
            selecteable
            name='tipoCodigoId'
            data={typeCodesSequence}
          />
        ),
        accessor: 'tipoCodigo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Serie' searcheable name='serie' />
        ),
        accessor: 'serie',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            selecteable
            name='estadoCorrelativoId'
            data={status}
          />
        ),
        accessor: 'estadoCorrelativo',
      },
    ],
    [selectedOn, companyList, clientList, siteList, campList, status, typeCodesSequence, data],
  )

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  const handleEnableSelected = async () => {
    setLoading(true)
    try {
      const selectedData = data.filter((item) => selected.includes(item.id))
      const filteredData = selectedData.filter(
        (item: MSquentialColumnModel) => item.estadoCorrelativo === 'DIS',
      )
      if (filteredData.length > 0) {
        ShowSnackBar(
          'Algunos de los elementos seleccionados ya se encuentran habilitados',
          'warning',
        )
        return
      }
      const response = await updateStatusManagementSequential({
        correlativoIds: selected.map((item) => item.toString()),
        estadoCorrelativoAcronimo: 'DIS',
      })
      if (!response.data.error) {
        ShowSnackBar('Estado actualizado correctamente', 'success')
        clearSelected()
        getManagementSequentialList()
      } else {
        console.error('Error updating status:', response.data.messageSystem)
        ShowSnackBar('Error al actualizar el estado', 'error')
      }
    } catch (error) {
      console.error('Error updating status:', error)
      ShowSnackBar('Error al actualizar el estado', 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleDisableSelected = async () => {
    setLoading(true)
    try {
      const selectedData = data.filter((item) => selected.includes(item.id))
      const filteredData = selectedData.filter(
        (item: MSquentialColumnModel) => item.estadoCorrelativo === 'INH',
      )
      if (filteredData.length > 0) {
        ShowSnackBar(
          'Algunos de los elementos seleccionados ya se encuentran inhabilitados',
          'warning',
        )
        return
      }
      const response = await updateStatusManagementSequential({
        correlativoIds: selected.map((item) => item.toString()),
        estadoCorrelativoAcronimo: 'INH',
      })
      if (!response.data.error) {
        ShowSnackBar('Estado actualizado correctamente', 'success')
        clearSelected()
        getManagementSequentialList()
      } else {
        console.error('Error updating status:', response.data.messageSystem)
        ShowSnackBar('Error al actualizar el estado', 'error')
      }
    } catch (error) {
      console.error('Error updating status:', error)
      ShowSnackBar('Error al actualizar el estado', 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteSelected = async () => {
    setLoading(true)
    try {
      const selectedData = data.filter((item) => selected.includes(item.id))
      const filteredData = selectedData.filter(
        (item: MSquentialColumnModel) => item.estadoCorrelativo !== 'DIS',
      )
      if (filteredData.length > 0) {
        ShowSnackBar(
          'Algunos de los elementos seleccionados no se encuentran disponibles para ser eliminados',
          'warning',
        )
        return
      }
      const response = await deleteManagementSequential({
        correlativoIds: selected.map((item) => item.toString()),
      })
      if (!response.data.error) {
        ShowSnackBar('Secuencia eliminada correctamente', 'success')
        clearSelected()
        getManagementSequentialList()
      } else {
        console.error('Error updating status:', response.data.messageSystem)
        ShowSnackBar('Error al eliminar la secuencia', 'error')
      }
    } catch (error) {
      console.error('Error updating status:', error)
      ShowSnackBar('Error al eliminar la secuencia', 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <div className='d-flex justify-content-end p-2 me-5'>
            <button
              type='button'
              className='btn btn-success me-3'
              onClick={handleEnableSelected}
              disabled={selected.length < 1}
            >
              Habilitar
            </button>
            <button
              type='button'
              className='btn btn-success me-3'
              onClick={handleDisableSelected}
              disabled={selected.length < 1}
            >
              Inhabiitar
            </button>
            <button
              type='button'
              className='btn btn-primary me-3'
              onClick={handleDeleteSelected}
              disabled={selected.length < 1}
            >
              Eliminar
            </button>
          </div>
          <KTable data={data} columns={columns as any} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableManagementSequentialWrapper = () => {
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <TableManagementSequential />
      </div>
    </KTableProvider>
  )
}

export {TableManagementSequentialWrapper}
